/**
 * <hero-slider> — auto-advance hero met dots + prev/next.
 * Alle visibility/reduced-motion/pause-logica zit in AutoplayController
 * (assets/autoplay-controller.js) zodat het uniform is met andere sliders.
 */
class HeroSlider extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-initialized')) return;
    this.setAttribute('data-initialized', '');

    this.track = this.querySelector('[data-hs-track]');
    this.prevBtn = this.querySelector('[data-hs-prev]');
    this.nextBtn = this.querySelector('[data-hs-next]');
    this.dots = Array.from(this.querySelectorAll('[data-hs-dot]'));
    if (!this.track) return;

    this.slides = Array.from(this.track.children);
    if (this.slides.length <= 1) return;

    this.interval = Number(this.getAttribute('data-autoplay')) || 6000;
    this._timer = null;
    this._current = 0;

    this.prevBtn?.addEventListener('click', () => this._go(this._current - 1, true));
    this.nextBtn?.addEventListener('click', () => this._go(this._current + 1, true));
    this.dots.forEach((d, i) => d.addEventListener('click', () => this._go(i, true)));

    this._onTouchStart = () => this._ctrl?.pause();
    this._onTouchEnd   = () => this._ctrl?.resume();
    this.track.addEventListener('touchstart', this._onTouchStart, { passive: true });
    this.track.addEventListener('touchend',   this._onTouchEnd);

    this.track.addEventListener('scroll', () => this._updateFromScroll());

    this._ctrl = new AutoplayController(this, {
      onEnable:  () => this._startTimer(),
      onDisable: () => this._stopTimer(),
    });
  }

  disconnectedCallback() {
    this._stopTimer();
    this._ctrl?.destroy();
  }

  _startTimer() {
    this._stopTimer();
    this._timer = setInterval(() => this._go(this._current + 1, false), this.interval);
  }
  _stopTimer() { clearInterval(this._timer); this._timer = null; }

  _go(index, userInitiated) {
    const total = this.slides.length;
    const next = ((index % total) + total) % total;
    const target = this.slides[next];
    if (!target) return;
    this.track.scrollTo({
      left: target.offsetLeft,
      behavior: this._ctrl?.reduced ? 'auto' : 'smooth',
    });
    this._current = next;
    this._updateDots();
    if (userInitiated && this._timer) this._startTimer();
  }

  _updateFromScroll() {
    const w = this.track.clientWidth;
    if (!w) return;
    const idx = Math.round(this.track.scrollLeft / w);
    if (idx !== this._current) {
      this._current = idx;
      this._updateDots();
    }
  }

  _updateDots() {
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this._current));
  }
}

if (!customElements.get('hero-slider')) {
  customElements.define('hero-slider', HeroSlider);
}
